import ApplicationController from "./application_controller.js";

export default class extends ApplicationController {
  static values = { eventBlock: String };

  connect() {
    if (this.hasEventBlockValue) {
      this.eventNames.forEach((event) => {
        this.element.addEventListener(event, this.blockBubble);
      });
    }
  }

  disconnect() {
    if (this.hasEventBlockValue) {
      this.eventNames.forEach((event) => {
        this.element.removeEventListener(event, this.blockBubble);
      });
    }
  }

  get eventNames() {
    if (this.hasEventBlockValue) {
      return this.eventBlockValue.split(/\s+/);
    } else {
      return [];
    }
  }

  blockBubble(e) {
    if (e.eventPhase == Event.BUBBLING_PHASE) {
      e.stopPropagation();
    }
  }
}
